import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import Pluralize from 'react-pluralize';
import { createModal } from 'react-modal-promise';
import { Typeahead } from 'react-bootstrap-typeahead';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import ErrorMessage from '../ErrorMessage';

function CategoryModal(props) {
  const accessoryConfig = props.accessoryConfig || {};
  const categories = accessoryConfig.categories || [];

  const [error, setError] = useState('');
  const [selected, setSelected] = useState([]);
  const [category, setCategory] = useState(props.category || { id: uuid() });
  const [accessories, setAccessories] = useState(
    accessoryConfig.accessories || [],
  );

  const isIncluded = (accessory) =>
    (accessory.categoryIds || []).includes(category.id);

  const toggleCategory = (accessory) => {
    let categoryIds = accessory.categoryIds || [];
    if (isIncluded(accessory)) {
      categoryIds = categoryIds.filter((id) => id !== category.id);
    } else {
      categoryIds.push(category.id);
    }

    const newAccessories = accessories.map((a) => {
      if (a.id === accessory.id) {
        return { ...a, categoryIds };
      }
      return a;
    });

    setAccessories(newAccessories);
  };

  const onSubmit = () => {
    if (!category.name) {
      setError('Category name is required');
    } else if (
      categories.some((c) => c.name === category.name && c.id !== category.id)
    ) {
      setError('Category with such name already exists');
    } else {
      setError('');

      const categoryIdx = categories.findIndex((c) => c.id === category.id);
      if (categoryIdx > -1) {
        categories[categoryIdx] = category;
      } else {
        categories.push(category);
      }

      const newAccessoryConfig = {
        accessories,
        categories,
      };
      props.updateConfig(newAccessoryConfig);
      props.close(true);
    }
  };

  const available = accessories.filter((a) => !isIncluded(a));
  const included = accessories.filter((a) => isIncluded(a));

  const removeButtonFormat = React.useCallback(
    (_, accessory) => (
      <button
        type="button"
        className="btn btn-default"
        onClick={() => toggleCategory(accessory)}
      >
        {'<'} Remove
      </button>
    ),
    [toggleCategory],
  );

  return (
    <div className="p-modal-container">
      <div className="p-modal accessory-modal">
        <h3>{!category ? 'Add Category' : 'Modify Category'}</h3>
        <i
          onClick={() => props.close(false)}
          className="modal-close close icon"
          alt="close"
        />
        <div className="p-modal-body">
          <form className="p-form">
            {error && <ErrorMessage error={error} />}
            <div className="row">
              <div className="col-sm-4 form-group">
                <label>Name</label>
                <input
                  name="name"
                  className="form-control"
                  value={category.name || ''}
                  onChange={(e) =>
                    setCategory({ ...category, name: e.target.value })
                  }
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4 form-group">
                <label>Add Accessory to Category</label>
                <Typeahead
                  id="category-typeahead"
                  className="picker"
                  selectHintOnEnter
                  clearButton
                  options={available}
                  selected={selected}
                  labelKey="name"
                  onChange={(value) => {
                    setSelected(value);
                  }}
                />
              </div>
              <div className="col-sm-1">
                <button
                  type="button"
                  className="btn btn-primary category-add-btn"
                  disabled={!selected.length}
                  onClick={() => {
                    toggleCategory(selected[0]);
                    setSelected([]);
                  }}
                >
                  Add {'>>'}
                </button>
              </div>
              <div className="col-sm-7">
                <b>
                  <Pluralize
                    singular="Accessory"
                    plural="Accessories"
                    count={included.length}
                  />
                </b>
                <BootstrapTable
                  striped
                  hover
                  data={included}
                  tableStyle={{ border: 'none' }}
                >
                  <TableHeaderColumn dataField="id" hidden isKey />
                  <TableHeaderColumn dataField="partNumber">
                    Part Number
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="name">Name</TableHeaderColumn>
                  <TableHeaderColumn
                    width="20%"
                    dataFormat={removeButtonFormat}
                  />
                </BootstrapTable>
              </div>
            </div>
          </form>
        </div>
        <div className="accessory-modal-footer">
          <button
            type="button"
            className="btn btn-default"
            onClick={() => props.close(false)}
          >
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={onSubmit}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

CategoryModal.propTypes = {
  accessoryConfig: PropTypes.object,
  category: PropTypes.object,
  close: PropTypes.func,
  updateConfig: PropTypes.func,
};

export default createModal(CategoryModal);
